import card1 from "../Assets/Images/card1.png";
import card2 from "../Assets/Images/card2.png";
import card3 from "../Assets/Images/card3.png";
import card4 from "../Assets/Images/card4.png";
import card5 from "../Assets/Images/card5.png";
import card6 from "../Assets/Images/card6.png";

export const experiencesData = [
  {
    image: card1,
    title: "Yosemite National Park, California",
    type: "Day tour",
    rating: 4.8,
    time: "10 Hours",
    Salesprice: 120,
    price: 150,
  },
  {
    image: card2,
    title: "Jackson Hole, Wyoming",
    type: "Adventure type",
    rating: 4.8,
    time: "6 Hours",
    price: 200,
    Salesprice: 150,
  },
  {
    image: card3,
    title: "Sedona, Arizona",
    type: "Relaxation type",
    rating: 4.8,
    time: "8 Hours",
    price: 150,
    Salesprice: 122,
  },
  {
    image: card3,
    title: "Sedona, Arizona",
    type: "Relaxation type",
    rating: 4.8,
    time: "8 Hours",
    price: 150,
    Salesprice: 122,
  },
];
export const trendingExperiencesData = [
  {
    image: card4,
    title: "Santa Fe, New Mexico",
    type: "Adventure Type",
    rating: 4.8,
    time: "6 Hours",
    price: 130,
  },
  {
    image: card5,
    title: "Newport, Rhode Island",
    type: "Adventure Type",
    rating: 4.8,
    time: "4 Hours",
    price: 200,
  },
  {
    image: card6,
    title: "Lake Tahoe, California",
    type: "Relaxation Type",
    rating: 4.8,
    time: "8 Hours",
    price: 150,
  },
];
export const experiencesMainData = [
  {
    image: card1,
    title: "Yosemite National Park, California",
    type: "Day tour",
    rating: 4.8,
    time: "10 Hours",
    price: 150,
  },
  {
    image: card2,
    title: "Jackson Hole, Wyoming",
    type: "Adventure type",
    rating: 4.8,
    time: "6 Hours",
    price: 200,
  },
  {
    image: card3,
    title: "Sedona, Arizona",
    type: "Relaxation type",
    rating: 4.8,
    time: "8 Hours",
    price: 150,
  },
  {
    image: card1,
    title: "Yosemite National Park, California",
    type: "Day tour",
    rating: 4.8,
    time: "10 Hours",
    price: 150,
  },
  {
    image: card2,
    title: "Jackson Hole, Wyoming",
    type: "Adventure type",
    rating: 4.8,
    time: "6 Hours",
    price: 200,
  },
  {
    image: card3,
    title: "Sedona, Arizona",
    type: "Relaxation type",
    rating: 4.8,
    time: "8 Hours",
    price: 150,
  },
  {
    image: card1,
    title: "Yosemite National Park, California",
    type: "Day tour",
    rating: 4.8,
    time: "10 Hours",
    price: 150,
  },
  {
    image: card2,
    title: "Jackson Hole, Wyoming",
    type: "Adventure type",
    rating: 4.8,
    time: "6 Hours",
    price: 200,
  },
  {
    image: card3,
    title: "Sedona, Arizona",
    type: "Relaxation type",
    rating: 4.8,
    time: "8 Hours",
    price: 150,
  },
  {
    image: card3,
    title: "Sedona, Arizona",
    type: "Relaxation type",
    rating: 4.8,
    time: "8 Hours",
    price: 150,
  },
  {
    image: card1,
    title: "Yosemite National Park, California",
    type: "Day tour",
    rating: 4.8,
    time: "10 Hours",
    price: 150,
  },
  {
    image: card2,
    title: "Jackson Hole, Wyoming",
    type: "Adventure type",
    rating: 4.8,
    time: "6 Hours",
    price: 200,
  },
];
export const highlights = [
  {
    text: "Thrilling rides like 'Tornado' and 'Bonzai Pipelines' for adrenaline lovers.",
  },
  {
    text: "A large pool with crashing waves, perfect for floating or riding the surf.",
  },
  {
    text: "A relaxing float along the 'River Cruise' for a laid-back experience.",
  },
  {
    text: "Dedicated zones like 'Castaway Cove' for younger children with shallow pools and mini slides.",
  },
  {
    text: "A variety of interactive water features and splash zones throughout the park.",
  },
];
export const reviewsData = [
  {
    name: "John Ralph",
    rating: 5,
    comment:
      "A fun and exciting water park with thrilling slides, a relaxing lazy river, and a great wave pool. Perfect for families and adrenaline seekers alike.",
  },
  {
    name: "Emily Davis",
    rating: 4,
    comment:
      "Great park with lots of fun activities. Could use more shaded areas, but overall a fantastic experience.",
  },
  {
    name: "Mark Spencer",
    rating: 5,
    comment:
      "Amazing experience! The staff was friendly, and the rides were incredible. Highly recommended.",
  },
  {
    name: "Anna Taylor",
    rating: 4,
    comment:
      "Perfect for a family day out. The kids loved it! The food could be better, but the rides make up for it.",
  },
  {
    name: "Anna Taylor",
    rating: 5,
    comment:
      "Perfect for a family day out. The kids loved it! The food could be better, but the rides make up for it.",
  },
];
export const bookingsData = [
  {
    id: 1,
    destination: "Six Flags Hurricane",
    location: "Harbor, California",
    date: "13/Nov/2024",
    participants: 5,
    price: 220,
    status: "Cancel Booking",
    outlined: false,
  },
  {
    id: 2,
    destination: "Six Flags Hurricane",
    location: "Harbor, California",
    date: "17/Aug/2024",
    participants: 5,
    price: 220,
    status: "Pending",
    outlined: true,
  },
  {
    id: 3,
    destination: "Six Flags Hurricane",
    location: "Harbor, California",
    date: "13/Nov/2024",
    participants: 5,
    price: 220,
    status: "Rejected",
    outlined: false,
  },
  {
    id: 4,
    destination: "Six Flags Hurricane",
    location: "Harbor, California",
    date: "13/Nov/2024",
    participants: 5,
    price: 220,
    status: "Timed out",
    outlined: true,
  },
  {
    id: 5,
    destination: "Six Flags Hurricane",
    location: "Harbor, California",
    date: "13/Nov/2024",
    participants: 5,
    price: 220,
    status: "Cancelled",
    outlined: true,
  },
];
export const experienceData = [
  {
    "S.no": 1,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 2,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 3,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 4,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 5,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 6,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 7,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 8,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 9,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 10,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 2,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 3,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 4,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 5,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 6,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 7,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 8,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 9,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 10,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 2,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 3,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 4,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 5,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 6,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 7,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 8,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 9,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
  {
    "S.no": 10,
    Title: "Six Flags Hurricane Harbor",
    Location: "California, USA",
    "Experience Type": "Adventure",
  },
];
export const users = [
  {
    "S.no": 1,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 2,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 3,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 4,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 5,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 6,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 7,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 8,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 9,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
  {
    "S.no": 10,
    name: "Jordan",
    Email: "jordan@gmail.com",
    lastBookingDate: "13/Oct/2024",
  },
];
export const bookingData = [
  {
    sNo: 1,
    userName: "Johnson",
    userType: "Guest",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Pending",
  },
  {
    sNo: 2,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Pending",
  },
  {
    sNo: 3,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Upcoming",
  },
  {
    sNo: 4,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Upcoming",
  },
  {
    sNo: 5,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Upcoming",
  },
  {
    sNo: 6,
    userName: "Johnson",
    userType: "Guest",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Timed out",
  },
  {
    sNo: 7,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Timed out",
  },
  {
    sNo: 8,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Cancelled",
  },
  {
    sNo: 9,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Cancelled",
  },
  {
    sNo: 10,
    userName: "Johnson",
    userType: "Registered",
    date: "15/Nov/2024",
    participant: 5,
    destination: "Six Flags Hurricane Harbor, California",
    status: "Cancelled",
  },
];
export const analyticsData = [
  {
    sNo: 1,
    experience: "Acadia National Park, Maine",
    bookings: 35,
    totalRevenue: 2000,
  },
  {
    sNo: 2,
    experience: "Six Flags Hurricane Harbor, California",
    bookings: 30,
    totalRevenue: 1600,
  },
  {
    sNo: 3,
    experience: "Acadia National Park, Maine",
    bookings: 28,
    totalRevenue: 1500,
  },
  {
    sNo: 4,
    experience: "Acadia National Park, Maine",
    bookings: 22,
    totalRevenue: 1500,
  },
  {
    sNo: 5,
    experience: "Acadia National Park, Maine",
    bookings: 21,
    totalRevenue: 1000,
  },
  {
    sNo: 6,
    experience: "Acadia National Park, Maine",
    bookings: 18,
    totalRevenue: 1000,
  },
  {
    sNo: 7,
    experience: "Acadia National Park, Maine",
    bookings: 15,
    totalRevenue: 1100,
  },
  {
    sNo: 8,
    experience: "Acadia National Park, Maine",
    bookings: 11,
    totalRevenue: 1000,
  },
  {
    sNo: 9,
    experience: "Acadia National Park, Maine",
    bookings: 11,
    totalRevenue: 1000,
  },
  {
    sNo: 10,
    experience: "Acadia National Park, Maine",
    bookings: 10,
    totalRevenue: 900,
  },
];
export const paymentsData = [
  {
    sNo: 1,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 2,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 3,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 4,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 5,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 6,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 7,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 8,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 9,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
  {
    sNo: 10,
    user: "John",
    date: "11/Nov/2024",
    amount: "$200",
    status: "Completed",
  },
];
export const barcodeData = [
  {
    sNo: 1,
    barcode: "1011110022343",
    category: "Child",
    Status: "UNUSED",
    Date: "27/Nov/2024",
    experience: "Lake Thaoe",
  },
  {
    sNo: 2,
    barcode: "5509210022343",
    category: "Adult",
    Status: "UNUSED",
    Date: "27/Nov/2024",
    experience: "Dream World",
  },
  {
    sNo: 3,
    barcode: "5509164522343",
    category: "Adult",
    Status: "UNUSED",
    Date: "27/Nov/2024",
    experience: "Six Flags Hurricane Harbor",
  },
  {
    sNo: 4,
    barcode: "2309148522354",
    category: "Adult",
    Status: "USED",
    Date: "27/Nov/2024",
    experience: "Winter Land",
  },
  {
    sNo: 5,
    barcode: "2909145222354",
    category: "Child",
    Status: "USED",
    Date: "27/Nov/2024",
    experience: "Adventure Land",
  },
  {
    sNo: 6,
    barcode: "3014145617354",
    category: "Child",
    Status: "USED",
    Date: "27/Nov/2024",
    experience: "Frozen Park",
  },
  {
    sNo: 7,
    barcode: "4848463210001",
    category: "Adult",
    Status: "USED",
    Date: "27/Nov/2024",
    experience: "Fun Land",
  },
  {
    sNo: 8,
    barcode: "8533113215661",
    category: "Adult",
    Status: "USED",
    Date: "27/Nov/2024",
    experience: "New Land Park",
  },
  {
    sNo: 9,
    barcode: "6688421098771",
    category: "Child",
    Status: "UNUSED",
    Date: "27/Nov/2024",
    experience: "Safari Adventure Park",
  },
  {
    sNo: 10,
    barcode: "9258790211098",
    category: "Child",
    Status: "USED",
    Date: "27/Nov/2024",
    experience: "Wild Adventure Land",
  },
];

export const category = [
  { value: "Child", label: "Child" },
  { value: "Adult", label: "Adult" },
  { value: "Senior", label: "Senior" },
];
export const adventure = [{ value: "adventureLand", label: "Adventure Land" }];

export const Months = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const currentYear = new Date().getFullYear();
export const years = Array.from({ length: 6 }, (_, i) => {
  const year = currentYear - i;
  return { value: year, label: year.toString() };
});

export const currencyOptions = [
  { value: "$", label: "USD", image: require("../Assets/Images/usd.png") },
  { value: "€", label: "EUR", image: require("../Assets/Images/euro.png") },
  { value: "£", label: "GBP", image: require("../Assets/Images/gbp.png") },
  { value: "₹", label: "INR", image: require("../Assets/Images/inr.png") },
  { value: "A$", label: "AUD", image: require("../Assets/Images/aud.png") },
  { value: "د.إ", label: "AED", image: require("../Assets/Images/aed.png") },
  { value: "﷼", label: "SAR", image: require("../Assets/Images/sar.png") },
];

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()]; 
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
